import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/aceites/filtro_aceite.svg")